import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cscomment(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
<Sides/>
<Helmet>
 
 <title>C# comments tutorial For Beginners</title>
 <meta name="description" content="C# comments tutorial for beginners.Comments in C# are only for you to read.If you type any type of contents inside C# comments are ignored by the compiler. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# comments,c# comments for,how csharp comment works" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-comments" />
 </Helmet>

 <div className='lg:pl-56'>
<h1 className="m-4 mh1">Types Of Comment in C# </h1>
<div className="first">
        <a href="/csharp-first-program">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-keyword">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, Comments in C# are only for you to read.
<br/>2, If you type any type of contents inside C# comments  are ignored by the compiler
</p>
<h2 className="mt-4 mh2">C# Comments Examples:</h2>


<h2 className='headings'>Q-Write the Basic Example of Csharp Program ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#47;* hello ram</span>
            {"\n"}
            <span className="qwerty-2">Hello, Bharat */</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<h2 className=" mt-4 mh2"> There are 3 Types of Comments in a c# programming language</h2>
<h3 className="mt-4  mh3 bold">1, Single-line Comment<br/>
2, Multi-line comment<br/>
3, XML Documentation Comments or Csharp doc Comments

</h3>
<p className="mt-4 para">1, <span className="bold ">Single-line comment</span>-<br/><br/>This single-line comment starts with a &#47;&#47; tag and ends at the end of the line.
</p>


<h2 className='head3'>Single-line Comments in C# example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-10">&#47;&#47; my name is codeexampler.com</span>
            {"\n"}
            <span className="qwerty-4">&#47;&#47;this is a Csharp programming</span>
            {"\n"}{"\n"} 
          </code>
        </pre>
      </div>

<p className="mt-4 para">2,<span className="bold"> Multiline Comment</span>-<br/><br/>This is a multi-line comment in c# and This type of comment must begin with /* and end with */.if you write anything inside this comment symbols is ignored by the compiler</p>



<h2 className='head3'>Multiline Comments in C# Example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
          <span className="qwerty-2">&#47;*</span>
            <span className="qwerty-10"> My name is CodeExampler.com</span>
            {"\n"}
            <span className="qwerty-4">This is a C# programming </span>
            <span className="qwerty-2">*&#47; </span>
            {"\n"}{"\n"}  
          </code>
        </pre>
        </div>
<p className="mt-4 para">3,<span className="bold">XML documentation comment or c# doc comment-</span><br/><br/>This type of comment is used in create documentation comment and this is also known as c# doc comment.
</p>


<h2 className='head3'>XML documentation comment in c# example:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
          {"\n"}
          <span className="qwerty-7">&#47;&#47;&#47; </span>
          <span className="qwerty-4">&#60;</span>
            <span className="qwerty-10">summary</span>
            <span className="qwerty-4">&#62;</span>
            {"\n"}
            <span className="qwerty-7">&#47;&#47;&#47; </span>
            <span className="qwerty-2">This summary is used to create the Documentation of </span>
            <span className="qwerty-4">c# </span>
            {"\n"}
            <span className="qwerty-7">&#47;&#47;&#47; </span>
          <span className="qwerty-4">&#60;</span>
            <span className="qwerty-10">summary</span>
            <span className="qwerty-4">&#62;</span>
            {"\n"}  {"\n"}
          
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-first-program">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-keyword">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cscomment;